module.exports = __webpack_public_path__ + "img/比赛竞技类.df5d3bad.png";